import React, { Component, useEffect, useState } from 'react';
import RedeemPassView from './RedeemPassView';
import crmservices from '../../wsclient/crmservices';
import { isValidEmail, validPhoneNumber } from '../../utils/util';
import ModalAlert from '../../components/ModalAlert';
import t from '../../utils/translateUtil';
import Loading from '../../components/Loading';
import { callRefreshWalletListeners, getAppCfg, initOptionHeader, setContacts } from '../../utils/common';
import { useTranslation } from 'react-i18next';

function RedeemPassController(props) {
    const [showLoading, onShowLoading] = useState(false);
    const [error, setError] = useState({
        showAlert: false,
        title: '',
        message: '',
        status: '',
    });
    const { t } = useTranslation();
    const onRedeem = async(value) =>{
        console.log('onRedeem value=', value);
        onShowLoading(true);
            try {
                var result = await crmservices.contacts.redeemAPass({
                    code: value.pass_code,
                    pin: value.pass_pin,
                });
                if (result.code === 'OK') {
                    showAlert(true, t('REDEEM_A_PASS_SUCCESS'), t('SUCCESS'));
                    callRefreshWalletListeners();
                }else if(result.code=='REDEEM_PASS_INVALID'){
                    showAlert(true, t('REDEEM_PASS_INVALID'), t('ERROR'));
                }else if(result.code=='REDEEM_PASS_USED'){
                    showAlert(true, t('REDEEM_PASS_USED'), t('ERROR'));
                }else{
                    showAlert(true, t('REDEEM_A_PASS_FAIL'), t('ERROR'));
                }
            } catch (error) {
                showAlert(true, t('EXCEPTION_PROCESS'), t('ERROR'));
            }
            onShowLoading(false);
    }
    const showAlert = (status, message, title) =>{
        onShowLoading(false);
        setError({
            showAlert: true,
            title: title,
            message: message,
            status: status,
        });
    }
    const onCloseAlert = async() =>{
        onShowLoading(false);
        setError({
            showAlert: false,
            title: '',
            message: '',
            status: '',
        });
    }
    return (
        <div>
            <ModalAlert
                open={error.showAlert}
                onClose={onCloseAlert}
                hideHeader={true}
                message={error.message}
                error={error.status}
                title={error.title}
            />
            <Loading showLoading={showLoading} />
            <RedeemPassView 
                onSubmit = {onRedeem}  
                open={props.open}
                onClose = {props.onClose}/>
                
        </div>
    );
}

export default RedeemPassController;